export default "__VITE_ASSET__da4b0f6f__"